import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Settings, Close16 } from 'ui/icons';
import { selectUserContext } from 'core/userContext';
import { getTheme } from 'utils/themes';
import { fetchCampaigns, fetchDashboardData, saveDashboard, saveWidget } from '../../actions';
import { getWidgetComponentFromType } from './widgets';
import { getWidgetType } from '../../utils/dashboardWidgetUtils';
import {
  selectDataForDashboardWidget,
  selectIsWidgetFetchingCampaigns,
  selectLayoutForDashboardWidget,
  selectNameForDashboardWidget,
  selectSettingsForDashboardWidget,
  selectVisualizationForDashboardWidget,
  selectWidgetForDashboardWidget,
} from '../../selectors';
import {
  DashboardWidgetActions,
  ActionDefaultGhostButton,
  ActionDarkGhostButton,
  StyledSkeleton,
  DashboardWidgetName,
} from '../Dashboard.styled';

// type Props = {
//   /** Dashboard widget data. */
//   data: {},
//   /** If widget is fetching campaigns. */
//   isFetchingCampaigns: boolean,
//   /** Dashboard panel layout data. */
//   layout: {},
//   /** Name of the widget. */
//   name: string,
//   /** Callback when delete button is clicked. */
//   onClickDelete: () => any,
//   /** Callback when edit button is clicked. */
//   onClickEdit: () => any,
//   /** Theme of the widget. */
//   theme: string,
//   /** Widget config data. */
//   widget: {},
// };

const defaultProps = {
  layout: {},
  onClickDelete: () => {},
  onClickEdit: () => {},
};

const DashboardWidget = (props) => {
  const { data, name, onClickDelete, onClickEdit, theme, widget, ...widgetProps } = props;

  const isLoading = !data;
  const widgetType = getWidgetType(widget);
  const WidgetComponent = getWidgetComponentFromType(widgetType);

  const themeDef = getTheme(theme);

  /**
   * handleClickDelete
   * Callback function when delete button is clicked.
   * @return { void }
   */
  const handleClickDelete = () => {
    onClickDelete(widget.id);
  };

  /**
   * handleClickEdit
   * Callback function when edit button is clicked.
   * @return { void }
   */
  const handleClickEdit = () => {
    const editWidget = {
      ...widget,
      originalWidget: Object.assign({}, widget),
    };
    onClickEdit(editWidget);
  };

  const Button = theme === 'default' ? ActionDefaultGhostButton : ActionDarkGhostButton;

  return isLoading ? (
    <StyledSkeleton />
  ) : (
    <>
      <WidgetComponent
        data={data}
        isLoading={isLoading}
        loadingInverted={!themeDef.loadingInverted}
        key="widget"
        theme={theme}
        widget={widget}
        {...widgetProps}
      />
      <DashboardWidgetName key="widgetName" theme={theme} data-role="name">
        {name}
      </DashboardWidgetName>
      <DashboardWidgetActions key="widgetActions" data-role="actions">
        <Button data-role="edit" onClick={handleClickEdit}>
          <Settings width={16} />
        </Button>
        <Button data-role="delete" onClick={handleClickDelete}>
          <Close16 />
        </Button>
      </DashboardWidgetActions>
    </>
  );
};

const mapStateToProps = (state, props) => ({
  data: selectDataForDashboardWidget(state, props),
  isFetchingCampaigns: selectIsWidgetFetchingCampaigns(state, props),
  layout: selectLayoutForDashboardWidget(state, props),
  name: selectNameForDashboardWidget(state, props),
  settings: selectSettingsForDashboardWidget(state, props),
  userContext: selectUserContext(state),
  visualization: selectVisualizationForDashboardWidget(state, props),
  widget: selectWidgetForDashboardWidget(state, props),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchCampaigns, fetchDashboardData, saveDashboard, saveWidget }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DashboardWidget);
DashboardWidget.defaultProps = defaultProps;
